import React from 'react';
import styles from './CadInformation.module.scss';
import { SFText } from 'sfui';
import { CADRMSReportValueType } from '../../../../Models/CadReportValue';

export interface CadInformationProps {
  data: CADRMSReportValueType;
}

export const CadInformation = ({
  data
}: CadInformationProps): React.ReactElement<CadInformationProps> => {
  return (
    <div className={styles.cadInformation}>
      <div className={styles.h4}>CAD Information</div>
      {data.cad?.id && (
        <div className={styles.infoItem}>
          <SFText type="component-messages" sfColor="neutral">
            CALL ID
          </SFText>
          <SFText type="component-1">{data.cad.id}</SFText>
        </div>
      )}

      {data.cad?.source && (
        <div className={styles.infoItem}>
          <SFText type="component-messages" sfColor="neutral">
            SOURCE
          </SFText>
          <SFText type="component-1">{data.cad.source}</SFText>
        </div>
      )}

      {data.cad?.type && (
        <div className={styles.infoItem}>
          <SFText type="component-messages" sfColor="neutral">
            TYPE
          </SFText>
          <SFText type="component-1">{data.cad.type}</SFText>
        </div>
      )}

      {data.cad?.priority && (
        <div className={styles.infoItem}>
          <SFText type="component-messages" sfColor="neutral">
            PRIORITY
          </SFText>
          <SFText type="component-1">{data.cad.priority}</SFText>
        </div>
      )}

      {data.cad?.disposition && (
        <div className={styles.infoItem}>
          <SFText type="component-messages" sfColor="neutral">
            DISPOSITION
          </SFText>
          <SFText type="component-1">{data.cad.disposition}</SFText>
        </div>
      )}
    </div>
  );
};
